module.exports = __webpack_public_path__ + "assets/img/portfolio-big-03.e2247d75.jpg";